var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMultipleUpdate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.92172 5.7071V8.8606L6.75481 10.0275C6.54535 10.237 6.54535 10.5766 6.75481 10.786C6.85957 10.8908 6.9968 10.9432 7.13412 10.9432C7.27138 10.9432 7.40867 10.8908 7.51343 10.786L8.83742 9.46206C8.93799 9.36148 8.9945 9.22503 8.9945 9.08278V5.7071C8.9945 5.41086 8.75436 5.17072 8.45811 5.17072C8.16186 5.17072 7.92172 5.41086 7.92172 5.7071Z",
    fill: "#CE718D",
    stroke: "#CE718D",
    strokeWidth: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.34123 4.48064C2.58973 2.52261 4.77007 1.30157 7.13423 1.30157C8.96814 1.30157 10.6923 2.01575 11.9891 3.3125C13.2858 4.6093 14 6.33344 14 8.16735C14 10.0013 13.2858 11.7254 11.9891 13.0222C10.6923 14.3189 8.96814 15.0331 7.13423 15.0331C7.12969 15.0331 7.12532 15.0326 7.12082 15.0325C7.11631 15.0326 7.11194 15.0331 7.10741 15.0331C6.91409 15.0331 6.71887 15.025 6.52711 15.0089C6.23191 14.9842 6.01264 14.7249 6.03734 14.4297C6.06209 14.1345 6.32109 13.9151 6.61664 13.9399C6.77873 13.9535 6.94383 13.9603 7.10741 13.9603C7.11194 13.9603 7.11631 13.9609 7.12082 13.961C7.12532 13.9609 7.12969 13.9603 7.13423 13.9603C10.3285 13.9603 12.9272 11.3616 12.9272 8.16735C12.9272 4.97307 10.3285 2.37435 7.13423 2.37435C5.07562 2.37435 3.18219 3.47162 2.14753 5.21721L2.15133 5.21081L1.34123 4.48064Z",
    fill: "#CE718D",
    stroke: "#CE718D",
    strokeWidth: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.25828 4.8025L1.30835 5.19935L1.7052 5.14929L4.38863 4.81078C4.50798 4.79572 4.62403 4.88577 4.63909 5.00512C4.65414 5.12447 4.56409 5.24052 4.44474 5.25558L1.14206 5.67221C1.02271 5.68726 0.906659 5.59721 0.891603 5.47786L0.474973 2.17518C0.459917 2.05583 0.549968 1.93978 0.669316 1.92472C0.788665 1.90967 0.904715 1.99972 0.91977 2.11907L1.25828 4.8025Z",
    fill: "#CE718D",
    stroke: "#CE718D",
    strokeWidth: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultipleUpdate);
export default __webpack_public_path__ + "static/media/multipleUpdate.0285afc693169073d99d0f8653865044.svg";
export { ForwardRef as ReactComponent };